<template lang="pug">
.g-select(:class="{ 'g-select--is-disabled': disabled}")
  h8.g-select__label {{title || ' '}}
  v-select.white(
    v-bind="{ ...$attrs, color, outlined, value, disabled }",
    :items="enabledItems",
    v-on="$listeners",
    dense,
    single-line,
    :menu-props="{ offsetY: true, contentClass }",
    :data-cy="dataCy",
  )
    slot(v-for="(_, name) in $slots", :name="name", :slot="name")
    template(v-for="(_, name) in $scopedSlots", :slot="name", slot-scope="slotData")
      slot(:name="name" v-bind="slotData")
</template>

<script>
export default {
  name: 'GSelect',
  props: {
    value: {},
    color: {
      type: String,
      default: 'normal',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => ([]),
    },
    title: {
      type: String,
      default: null,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    dataCy: {
      type: String,
      default: null,
    },
  },
  data: () => ({}),
  computed: {
    contentClass() {
      return `g-select__menu${this.$attrs['error-messages'] ? '--is-error' : ''}`;
    },
    enabledItems() {
      if(this.items) {
         return this.items.map(i => {
          if (i && typeof i === 'object' && i.disabled) return { ...i, disabled: false };
          return i;
      });
      }
      return [];
    },
  },
};
</script>

<style lang="scss">
@import "Select.scss";
</style>
